import styled from 'styled-components';
import { screen, spacing } from '../../../theme';

export const StyledHowSection = styled.ol`
  counter-reset: howItem;
  margin-top: ${spacing('lg')};
  margin-bottom: 0;
  padding-left: 0;

  @media (min-width: ${screen('md')}) {
    margin-top: ${spacing('xl')};
    column-count: 2;
    column-gap: ${spacing('xl')};
  }

  @media (min-width: ${screen('lg')}) {
    margin-top: ${spacing('xl4')};
    column-count: 3;
  }
`;
